import styled from '@emotion/styled';

export const SadaUserProfileDialog = styled.div``;
